import { createUrl, restGet, restPost } from '~/src/dash/api/rest';

// GET v1/settings/realtime_analytics
export async function queryRealtimeAnalytics(
  beginTime: string,
  endTime: string,
  siteIDs: string,
  demandSources: string,
  bidderIDs: string,
  testSiteIDs: string,
  siteBidder: string,
  siteDemandSource: string,
  networkIDs: string,
  networkChannelIDs: string,
  campaignIDs: string,
  deviceTypeIDs: string,
  siteDeviceTypeIDs: string,
  metrics: string,
  publisherID: string,
  byHour: boolean,
  testBidderIDs: string,
  dealIDs: string,
  InventoryRouteIDs: string,
  destinationIDs: string,
  bidderDeviceTypeIDs: string,
  automatedBidFloorIDs: string,
  byABFPeriod: string,
): Promise<[any?, Error?]> {
  const reqUrl =
    createUrl('/realtime_analytics', publisherID) +
    beginTime +
    endTime +
    siteIDs +
    demandSources +
    bidderIDs +
    testSiteIDs +
    siteBidder +
    siteDemandSource +
    networkIDs +
    networkChannelIDs +
    campaignIDs +
    deviceTypeIDs +
    siteDeviceTypeIDs +
    metrics +
    (byHour ? '&by_hour=true' : '') +
    testBidderIDs +
    dealIDs +
    InventoryRouteIDs +
    destinationIDs +
    bidderDeviceTypeIDs +
    automatedBidFloorIDs +
    byABFPeriod;

  try {
    const ret = (await restGet<any>(reqUrl, {})).parsedBody;
    return [ret, undefined];
  } catch (e) {
    console.error(e);
    return [undefined, e];
  }
}

// POST v1/settings/realtime_analytics
export async function queryRealtimeAnalyticsPOST(
  publisherID: string,
  beginTime: string,
  endTime: string,
  metrics: string,
  bidderIDs: string,
  siteBidderIDs: string,
  deviceTypeIDs: string,
  siteDeviceTypeIDs: string,
  byHour: boolean,
  testSiteIDs: string,
  testBidderIDs: string,
  bidderDeviceTypeIDs: string,
  publicaAuctionRequesters: string,
  publicaDeviceTypes: string,
  publicaBidderNames: string,
  publicaClusters: string,
  publicaRegions: string,
  biddernames: string,
  publica_publisher_ids: string,
): Promise<[any?, Error?]> {
  const requestURL = createUrl('/realtime_analytics', publisherID);
  try {
    const response = await restPost<any>(requestURL, {
      publisher_id: publisherID,
      begin_time: beginTime,
      end_time: endTime,
      metrics,
      bidder_ids: bidderIDs,
      site_bidder_ids: siteBidderIDs,
      device_types: deviceTypeIDs,
      site_device_types: siteDeviceTypeIDs,
      by_hour: byHour ? 'true' : 'false',
      test_site_ids: testSiteIDs,
      test_bidder_ids: testBidderIDs,
      biddername_device_type: bidderDeviceTypeIDs,
      publica_auction_requesters: publicaAuctionRequesters,
      publica_device_types: publicaDeviceTypes,
      publica_bidder_names: publicaBidderNames,
      publica_clusters: publicaClusters,
      publica_regions: publicaRegions,
      biddernames,
      publica_publisher_ids,
    });
    return [response.parsedBody, undefined];
  } catch (err) {
    console.error(err);
    return [undefined, err];
  }
}
